import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

// ANDed: `AdminPanel` aligns nav with the wrapper route + admin-section gate; the other three are the
// exact perms the mesh needs to mint a Marketplace token. Ships dark (`marketplace_session_view` is internal-only).
export const cartAssistantSessionDrilldownAccessControl: DomainAccessControlConfig = {
  permissions: [
    Permission.AdminPanel,
    Permission.StoreConfigsView,
    Permission.CartAssistantSessionView,
    Permission.CartAssistantMarketplaceSessionView,
  ],
}
